import { createReducer, on } from '@ngrx/store'
import { KpiMetric } from '@tradecafe/types/core'
import { createEntityAdapter, EntityState } from '@ngrx/entity'
import { DeepReadonly } from '@tradecafe/types/utils'
import * as KpiMetricsActions from './kpi-metrics.actions'

export const kpiMetricsFeatureKey = 'kpiMetrics'

export interface KpiMetricsState {
  truckKpis: EntityState<DeepReadonly<KpiMetric>>
  oceanKpis: EntityState<DeepReadonly<KpiMetric>>
  truckKpisLoading: boolean
  oceanKpisLoading: boolean
}

const selectTruckId = (kpi: KpiMetric) => kpi.kpi_metric_id
const selectOceanId = (kpi: KpiMetric) => kpi.kpi_metric_id

export const truckAdapter = createEntityAdapter<DeepReadonly<KpiMetric>>({ selectId: selectTruckId })
export const oceanAdapter = createEntityAdapter<DeepReadonly<KpiMetric>>({ selectId: selectOceanId })

const initialState: KpiMetricsState = {
  truckKpis: truckAdapter.getInitialState(),
  oceanKpis: oceanAdapter.getInitialState(),
  truckKpisLoading: true,
  oceanKpisLoading: true,
}

export const kpiMetricsReducer = createReducer(
  initialState,
  on(KpiMetricsActions.loadTruckKpis, (state) => ({
    ...state,
    truckKpisLoading: true,
  })),
  on(KpiMetricsActions.loadTruckKpisSuccess, (state, action) => ({
    ...state,
    truckKpis: truckAdapter.upsertMany(action.kpis, state.truckKpis),
    truckKpisLoading: false,
  })),
  on(KpiMetricsActions.loadTruckKpisFailure, (state) => ({
    ...state,
    truckKpisLoading: false,
  })),
  on(KpiMetricsActions.loadOceanKpis, (state) => ({
    ...state,
    oceanKpisLoading: true,
  })),
  on(KpiMetricsActions.loadOceanKpisSuccess, (state, action) => ({
    ...state,
    oceanKpis: oceanAdapter.upsertMany(action.kpis, state.oceanKpis),
    oceanKpisLoading: false,
  })),
  on(KpiMetricsActions.loadOceanKpisFailure, (state) => ({
    ...state,
    oceanKpisLoading: false,
  }))
)
